export function intersectRects(rectA, rectB) {
  const top = Math.max(rectA.top, rectB.top);
  const left = Math.max(rectA.left, rectB.left);
  const right = Math.min(rectA.right, rectB.right);
  const bottom = Math.min(rectA.bottom, rectB.bottom);
  const width = right - left;
  const height = bottom - top;
  return {
    top,
    left,
    right,
    bottom,
    width,
    height
  };
}